import Link from 'next/link';

/** tel:, mailto:, http(s):, viber: — external */
export function isExternalHref(href = '') {
  return /^(https?:|tel:|mailto:|viber:|javascript:)/i.test(href.trim());
}

/** Strip site domain; keep path-only for internal navigation */
export function normalizeAppPath(href = '/') {
  const value = (href || '/').trim();
  if (!value || value === '/') return '/';

  if (isExternalHref(value)) return value;

  try {
    if (value.startsWith('http://') || value.startsWith('https://')) {
      return new URL(value).pathname || '/';
    }
  } catch {
    /* relative or invalid URL */
  }

  return value.startsWith('/') ? value : `/${value}`;
}

/**
 * Internal route → next/link. tel:/mailto:/https: → <a>.
 */
export function AppLink({ to, href, className, children, ...rest }) {
  const target = (href ?? to ?? '/').trim();

  if (isExternalHref(target)) {
    return (
      <a href={target} className={className} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link href={normalizeAppPath(target)} className={className} {...rest}>
      {children}
    </Link>
  );
}
